angular.module('gym.calendar').controller('EditEventScheduleRestrictionsCtrl', ["$scope", "$rootScope", "$modalInstance", "EditEventService", "EventService", "flash", "ConfirmLeaveUnsavedChangesService", "params", function($scope, $rootScope, $modalInstance, EditEventService, EventService, flash, ConfirmLeaveUnsavedChangesService, params) {
  $scope.gym = $rootScope.gym;
  $scope.event = params.event;
  ConfirmLeaveUnsavedChangesService.watch($scope, 'event', {
    closeModal: function() {
      return $scope.close(true);
    }
  });
  $scope.restrictCancellationsUnits = EditEventService.getRestrictCancellationsUnits();
  $scope.bookingsAllowedAfterUnits = EditEventService.getBookingsAllowedAfterUnits();
  $scope.maxAttendeesTooltip = EventService.maxAttendeesTooltip();
  $scope.maxPropspectsTooltip = EventService.maxPropspectsTooltip();
  $scope.event.editScope = 'restrictions';
  $scope.getEventTypeName = function(id) {
    var eventType;
    eventType = _.find($scope.event.event_schedule_event_types, function(item) {
      return item.event_type_id === id;
    });
    return eventType != null ? eventType.event_type_name : void 0;
  };
  $scope.getErrors = function(key, index) {
    return $scope.event.errors[`${key}[${index}]`];
  };
  $scope.onClose = function() {
    params.cancelEdit();
    return $modalInstance.dismiss('cancel');
  };
  $scope.close = function(skipConfirmation) {
    if ($scope.displayConfirmationOnClose && !skipConfirmation) {
      if (window.confirm("Are you sure? This will abandon any unsaved changes.")) {
        return $scope.onClose();
      }
    } else {
      return $scope.onClose();
    }
  };
  $scope.onWaitlistToggle = function() {
    if (!$scope.event.waitlist_enabled) {
      return $scope.event.waitlist_limit = void 0;
    }
  };
  $scope.isValid = function() {
    return !$scope.isLoading && EditEventService.isParticipantLimitValid($scope.event);
  };
  return $scope.save = function() {
    $scope.isLoading = true;
    return params.save({
      event: $scope.event
    }).then(function(response) {
      return $scope.close(true);
    }, function(response) {
      $scope.event.errors = response.errors;
      return $scope.isLoading = false;
    });
  };
}]);
